import "./styles.css"
import type { TagProps } from "@site-types/components/tag"

export function Tag({ data }: TagProps) {
  if (data.length === 0) return null
  return (
    <ul className="column">
      {data.map((tag) => (
        <li
          className="tag"
          key={tag}
        >
          {tag}
        </li>
      ))}
    </ul>
  )
}

export default Tag
